// src/pages/eglises/AjouterTemple.jsx
import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { COLORS } from '../../constants/colors';

// ===== STYLES =====
const styles = `
  .dashboard-styled {
    background: #f4f6f9;
    min-height: 100vh;
  }

  /* En-tête moderne */
  .header-modern {
    background: white;
    padding: 1.2rem 1.8rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    border-left: 4px solid ${COLORS.secondary};
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .header-left {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    background: ${COLORS.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: white;
    font-size: 1.4rem;
  }

  .gradient-text {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
    margin: 0;
  }

  .badge-modern {
    background: #f1f4f9;
    color: #475569;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 0.75rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .badge-modern i {
    color: ${COLORS.secondary};
  }

  .btn-modern-outline {
    border: 1px solid #d1d5db;
    background: white;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: #4b5563;
    transition: all 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .btn-modern-outline:hover {
    border-color: ${COLORS.secondary};
    color: ${COLORS.secondary};
    background: #fafafa;
  }

  .btn-modern-primary {
    background: ${COLORS.primary};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-primary:hover {
    background: ${COLORS.primaryDark};
    box-shadow: 0 4px 10px rgba(41,90,167,0.3);
  }

  .btn-modern-success {
    background: ${COLORS.success};
    border: none;
    padding: 0.4rem 1.2rem;
    border-radius: 4px;
    font-size: 0.85rem;
    font-weight: 500;
    color: white;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
  }
  .btn-modern-success:hover {
    background: #059669;
    box-shadow: 0 4px 10px rgba(16,185,129,0.3);
  }

  /* Card */
  .card-modern {
    border: none;
    border-radius: 4px;
    background: white;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
    border-top: 3px solid transparent;
    transition: box-shadow 0.2s;
  }
  .card-modern:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.06);
  }
  .card-modern.border-primary {
    border-top-color: ${COLORS.primary};
  }

  .card-header-modern {
    background: transparent;
    border-bottom: 1px solid #e9edf2;
    padding: 0.8rem 1.2rem;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .card-header-modern i {
    color: ${COLORS.secondary};
  }

  .card-body-modern {
    padding: 1.5rem;
  }

  /* Form */
  .form-label-modern {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 0.2rem;
  }
  .form-label-modern .required {
    color: ${COLORS.danger};
    margin-left: 2px;
  }

  .form-control-modern, .form-select-modern {
    border: 1px solid #e2e8f0;
    border-radius: 4px;
    padding: 0.4rem 0.7rem;
    font-size: 0.85rem;
    transition: all 0.2s ease;
    background: white;
  }
  .form-control-modern:focus, .form-select-modern:focus {
    border-color: ${COLORS.primary};
    box-shadow: 0 0 0 3px rgba(41,90,167,0.08);
  }

  .form-text-modern {
    font-size: 0.7rem;
    color: #94a3b8;
    margin-top: 0.2rem;
  }

  /* Notifications */
  .toast-notification {
    padding: 0.8rem 1rem;
    border: none;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 1.5rem;
    animation: slideDown 0.3s ease-out;
    border-radius: 4px;
  }
  .toast-notification-success {
    background: #f0fdf4;
    border-left: 3px solid ${COLORS.success};
  }
  .toast-notification-error {
    background: #fef2f2;
    border-left: 3px solid ${COLORS.danger};
  }
  .toast-icon {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 1rem;
  }
  .toast-icon-success {
    background: rgba(16,185,129,0.15);
    color: ${COLORS.success};
  }
  .toast-icon-error {
    background: rgba(239,68,68,0.15);
    color: ${COLORS.danger};
  }
  .toast-content {
    flex: 1;
  }
  .toast-title {
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 1px;
  }
  .toast-message {
    font-size: 0.75rem;
    color: #64748b;
    margin: 0;
  }
  .toast-close {
    background: none;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px;
    font-size: 1rem;
  }

  .step-content {
    min-height: 300px;
  }

  /* Animations */
  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to { opacity: 1; transform: translateY(0); }
  }
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  @media (max-width: 768px) {
    .header-modern {
      flex-direction: column;
      align-items: stretch;
      gap: 0.8rem;
      padding: 1rem;
    }
    .header-left {
      flex-wrap: wrap;
    }
    .card-body-modern {
      padding: 1rem;
    }
  }
`;

export default function AjouterTemple() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [loadingEglises, setLoadingEglises] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [eglises, setEglises] = useState([]);
  const [userRole, setUserRole] = useState('');

  const [formData, setFormData] = useState({
    nom: '',
    tel: '',
    email: '',
    province: '',
    ville: '',
    adresse: '',
    date_at: '',
    matri_eglise: ''
  });

  useEffect(() => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      setUserRole(user.role);
    }
    fetchEglises();
  }, []);

  const fetchEglises = async () => {
    try {
      setLoadingEglises(true);

      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }

      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const response = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}&parent=siege&limit=1000`, {
        headers: { 'Accept': 'application/json' }
      });

      const result = await response.json();

      if (result.success) {
        setEglises(result.eglises || []);
      }
    } catch (err) {
      console.error('Erreur chargement églises:', err);
    } finally {
      setLoadingEglises(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        navigate('/pages/signin2');
        return;
      }

      const user = JSON.parse(userStr);
      const userId = user.id || user.id_utilisateur;

      const dataToSend = {
        ...formData,
        matri_parent: formData.matri_eglise,
        caisse: 0
      };

      const response = await fetch(`https://josephsbusiness.com/api/eglises.php?user_id=${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      const result = await response.json();

      if (result.success) {
        setSuccess(`Temple ajouté avec succès - Matricule: ${result.matricule}`);
        setTimeout(() => {
          navigate('/temples/liste');
        }, 2000);
      } else {
        setError(result.message || 'Erreur lors de l\'ajout');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{styles}</style>
      <Header />
      <div className="main main-app p-3 p-lg-4 dashboard-styled">
        <div className="container-fluid px-0">

          {/* ===== EN-TÊTE MODERNE ===== */}
          <div className="header-modern mb-4 fade-in">
            <div className="header-left">
              <div className="header-icon-wrapper">
                <i className="ri-add-line"></i>
              </div>
              <div>
                <h5 className="gradient-text">Ajouter un temple</h5>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge-modern">
                    <i className="ri-building-2-line"></i> Nouvelle filiale
                  </span>
                  <span className="badge-modern">
                    <i className="ri-calendar-line"></i> {new Date().toLocaleDateString('fr-FR')}
                  </span>
                </div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Button size="sm" className="btn-modern-outline" onClick={() => navigate('/temples/liste')}>
                <i className="ri-arrow-left-line"></i> Retour
              </Button>
            </div>
          </div>

          {/* ===== NOTIFICATIONS ===== */}
          {error && (
            <div className="toast-notification toast-notification-error mb-4">
              <div className="toast-icon toast-icon-error">
                <i className="ri-error-warning-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.danger }}>Erreur</div>
                <p className="toast-message">{error}</p>
              </div>
              <button className="toast-close" onClick={() => setError('')}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {success && (
            <div className="toast-notification toast-notification-success mb-4">
              <div className="toast-icon toast-icon-success">
                <i className="ri-checkbox-circle-line"></i>
              </div>
              <div className="toast-content">
                <div className="toast-title" style={{ color: COLORS.success }}>Succès</div>
                <p className="toast-message">{success}</p>
              </div>
              <button className="toast-close" onClick={() => setSuccess('')}>
                <i className="ri-close-line"></i>
              </button>
            </div>
          )}

          {/* ===== CARD PRINCIPALE ===== */}
          <Row className="justify-content-center">
            <Col md={8}>
              <Card className="card-modern border-primary">
                <Card.Header className="card-header-modern">
                  <i className="ri-information-line"></i> Informations du temple
                </Card.Header>
                <Card.Body className="card-body-modern">

                  <Form onSubmit={handleSubmit}>
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group controlId="nom">
                          <Form.Label className="form-label-modern">
                            Nom du temple <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="nom"
                            value={formData.nom}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                            placeholder="Nom du temple"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="tel">
                          <Form.Label className="form-label-modern">
                            Téléphone <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="tel"
                            value={formData.tel}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                            placeholder="Téléphone"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="email">
                          <Form.Label className="form-label-modern">
                            Email <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                            placeholder="Email"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="province">
                          <Form.Label className="form-label-modern">
                            Province <span className="required">*</span>
                          </Form.Label>
                          <Form.Select
                            name="province"
                            value={formData.province}
                            onChange={handleChange}
                            required
                            className="form-select-modern"
                          >
                            <option value="">Sélectionner la province</option>
                            <option value="Estuaire">Estuaire</option>
                            <option value="Haut-Ogooué">Haut-Ogooué</option>
                            <option value="Moyen-Ogooué">Moyen-Ogooué</option>
                            <option value="Ngounié">Ngounié</option>
                            <option value="Nyanga">Nyanga</option>
                            <option value="Ogooué-Ivindo">Ogooué-Ivindo</option>
                            <option value="Ogooué-Lolo">Ogooué-Lolo</option>
                            <option value="Ogooué-Maritime">Ogooué-Maritime</option>
                            <option value="Woleu-Ntem">Woleu-Ntem</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="ville">
                          <Form.Label className="form-label-modern">
                            Ville <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="ville"
                            value={formData.ville}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                            placeholder="Ville"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="adresse">
                          <Form.Label className="form-label-modern">
                            Adresse <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="adresse"
                            value={formData.adresse}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                            placeholder="Adresse"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="date_at">
                          <Form.Label className="form-label-modern">
                            Date de création <span className="required">*</span>
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="date_at"
                            value={formData.date_at}
                            onChange={handleChange}
                            required
                            className="form-control-modern"
                          />
                        </Form.Group>
                      </Col>

                      {(userRole === 'Super Administrateur' || userRole === 'Administrateur') && (
                        <Col md={6}>
                          <Form.Group controlId="matri_eglise">
                            <Form.Label className="form-label-modern">
                              Église mère <span className="required">*</span>
                            </Form.Label>
                            {loadingEglises ? (
                              <div className="d-flex align-items-center">
                                <Spinner size="sm" className="me-2" style={{ color: COLORS.primary }} />
                                <span className="text-muted small">Chargement des églises...</span>
                              </div>
                            ) : (
                              <Form.Select
                                name="matri_eglise"
                                value={formData.matri_eglise}
                                onChange={handleChange}
                                required
                                className="form-select-modern"
                              >
                                <option value="">Sélectionner l'église mère</option>
                                {eglises.map(eglise => (
                                  <option key={eglise.matricule} value={eglise.matricule}>
                                    {eglise.nom} - {eglise.ville} ({eglise.matricule})
                                  </option>
                                ))}
                              </Form.Select>
                            )}
                            <Form.Text className="form-text-modern">
                              <i className="ri-information-line me-1"></i>
                              Sélectionnez l'église à laquelle ce temple sera rattaché
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      )}

                      <Col md={12} className="mt-3">
                        <div className="d-flex gap-2 justify-content-end">
                          <Button
                            variant="light"
                            size="sm"
                            className="btn-modern-outline"
                            onClick={() => navigate('/temples/liste')}
                          >
                            Annuler
                          </Button>
                          <Button
                            type="submit"
                            size="sm"
                            className="btn-modern-success"
                            disabled={loading}
                          >
                            {loading ? (
                              <><Spinner size="sm" className="me-1" /> Enregistrement...</>
                            ) : (
                              <><i className="ri-check-line me-1"></i> Ajouter le temple</>
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>

                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Footer />
        </div>
      </div>
    </>
  );
}